import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

import english from './en.json'
import farsi from './fa.json'

const resources={
    en:{
        translation : english
    },
    fa:{
        translation : farsi
    }
}


 i18n
    .use(initReactI18next)
    .init({
    resources,
    lng:"fa"
})
export default  i18n;